import { render, staticRenderFns } from "./message-composer.vue?vue&type=template&id=9a261adc&scoped=true"
import script from "./message-composer.vue?vue&type=script&lang=js"
export * from "./message-composer.vue?vue&type=script&lang=js"
import style0 from "./message-composer.vue?vue&type=style&index=0&id=9a261adc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a261adc",
  null
  
)

export default component.exports